import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { SERVICE_ID_ROUTE_PARAM } from '@core/routes/utils/route-param';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { service as serviceSelector } from '@stores/services/services.selector';
import { selectIfDefined } from '@stores/utils/selects.operators';
import { Observable, map } from 'rxjs';

export const ServiceWithManyTabs: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<true | UrlTree> => {
  const serviceId = route.params[SERVICE_ID_ROUTE_PARAM] ?? route.data.serviceId;

  const router = inject(Router);
  const store = inject(Store);

  const servicesRoute = FeaturesRoutingEnum.Services;

  const service$ = selectIfDefined(store, serviceSelector(serviceId));

  return service$.pipe(
    map((service) => {
      const hasManyTabs = service.tabs.length > 1;
      return hasManyTabs ? true : router.parseUrl(`/${servicesRoute}/${serviceId}`);
    })
  );
};
